import * as React from 'react';
import { FormikProps } from 'formik';
import { Popover } from 'antd';
import { Table } from '@src/controls';
import { FormattedMessage } from '@src/i18n';
import { GroupPriceRuleFormValue, groupPriceRuleTranslations } from '../helpers';
import { CarrierProductModel } from '@src/models';
import { CarrierProductFormValue } from '.';
import { CreateGroupPriceRuleForm } from './create-group-price-rule-form';

interface OwnProps {
  regionId: string;
  product: CarrierProductModel;
  formProps: FormikProps<CarrierProductFormValue>;
  onPriceRuleChange: (values: CarrierProductFormValue) => void;
  onRuleRemove: (values: CarrierProductFormValue, ruleIndex: number) => void;
}

export const GroupPriceRulesTable: React.FunctionComponent<OwnProps> = ({
  regionId,
  formProps,
  onPriceRuleChange,
  onRuleRemove,
  product,
}) => {
  const [ruleEditPopoverVisible, setRuleEditPopoverVisible] = React.useState(false);
  const [selectedRuleIndex, setselectedRuleIndex] = React.useState(0);

  return (
    <Table
      dataSource={formProps.values.groupPriceRules}
      pagination={false}
      rowKey={(_, index) => `row_${index}`}
      hideTitle
      style={{ marginBottom: '8px' }}
    >
      <Table.Column<GroupPriceRuleFormValue>
        title="Type"
        key="type"
        render={(_, rule) => (
          <span>{groupPriceRuleTranslations[rule.type] ?? rule.type}</span>
        )}
      />
      <Table.Column<GroupPriceRuleFormValue>
        title={<FormattedMessage id="ACTIONS" />}
        key="actions"
        render={(_, _rule, index) => (
          <>
            <Popover
              trigger="click"
              title={<FormattedMessage id="EDIT_RULE" />}
              visible={index === selectedRuleIndex && ruleEditPopoverVisible}
              onVisibleChange={setRuleEditPopoverVisible}
              getPopupContainer={e => e.parentElement || document.body}
              content={
                <CreateGroupPriceRuleForm
                  regionId={regionId}
                  ruleIndex={selectedRuleIndex}
                  onSaveClick={() => setRuleEditPopoverVisible(false)}
                  product={product}
                />
              }
              destroyTooltipOnHide
            >
              <a onClick={() => setselectedRuleIndex(index)}>
                <FormattedMessage id="EDIT" />
              </a>
            </Popover>
            <a style={{ marginLeft: '20px' }} onClick={() => onRuleRemove(formProps.values, index)}>
              <FormattedMessage id="DELETE" />
            </a>
          </>
        )}
      />
    </Table>
  )
}
